import classNames from 'classnames'

import Text from '../../Text'

import * as styles from './RequestStatusSelectInfo.module.css'

function RequestStatusSelectInfo({
  className = styles.RequestStatusSelectInfo,
  value,
}) {
  const textColor = value?.textColor || null

  const infoClassName = classNames(className, {
    [styles.placeholder]: !textColor,
  })

  const infoStyle = textColor
    ? {
        '--request-status-select-info-bg': value?.backgroundColor,
        '--request-status-select-info-color': textColor,
      }
    : null

  return (
    <div className={infoClassName} style={infoStyle}>
      <Text className={styles.text}>{value?.label}</Text>
    </div>
  )
}

export default RequestStatusSelectInfo
